<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout justify-center row>
    <v-flex xs2>
      <SimpleCard>
        <DriverPhotosSearchBox
          @search="search"
          @clear="clear"
          :query="query"
        ></DriverPhotosSearchBox>
      </SimpleCard>
    </v-flex>
    <v-flex xs10 pl-2>
      <SimpleCard>
        <v-layout row wrap align-content-center justify-center>
          <DriverPhotosList
            ref="driverPhotosList"
            v-if="!loading"
            style="width: 100%"
            @refresh="refresh"
            :driverPhotos="driverPhotos"
            :pagination="pagination"
            :query="query"
          ></DriverPhotosList>
        </v-layout>
      </SimpleCard>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import DriverPhotosList from "@/components/driver/DriverPhotosList.vue";
import DriverPhotosSearchBox from "@/components/driver/DriverPhotosSearchBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "drivers",
  components: {
    SimpleCard,
    DriverPhotosList,
    DriverPhotosSearchBox,
  },
  data: function () {
    return {
      offset: 0,
      count: 20,
      query: {
        filter: "pending",
        searchQuery: "",
      },
      numPages: 0,
      driverPhotos: [],
    };
  },
  methods: {
    search: function () {
      console.log("Search");
      this.$refs.driverPhotosList.clearAndRefresh();
    },
    refresh: function () {
      this.$refs.driverPhotosList.refresh();
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>
